import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue-demi';
import {
  AbSection,
  AbTitle,
  AbDescription,
  AbContainer,
  AbSectionLayout,
  AbButton,
} from '../../ui';
import { DEFAULT_SPACING, Spacing } from '../../../helpers/shared-props';
import { CdnImg } from '@webplatform/cdn-image';
import { TextAlign } from '../../../types';

interface Props {
  id?: string;
  title?: string;
  description?: string;
  textAlign?: TextAlign;
  items: {
    image: {
      src: string;
      alt: string;
    };
    title: string;
    description: string;
    link: {
      src: string;
      text: string;
      align?: TextAlign;
    };
    contentAlign?: TextAlign;
  }[];
  spacing?: Spacing;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoCloudSectionWithFeatures',
  props: {
    id: null,
    title: null,
    description: null,
    textAlign: { default: 'center' },
    items: null,
    spacing: { default: () => DEFAULT_SPACING }
  },
  setup(__props: any) {

const props = __props as { id?: string, title?: string, description?: string, textAlign: TextAlign, items: {
    image: {
      src: string;
      alt: string;
    };
    title: string;
    description: string;
    link: {
      src: string;
      text: string;
      align?: TextAlign;
    };
    contentAlign?: TextAlign;
  }[], spacing: Spacing };



const activeItemIndex = ref(0);

const activeItem = computed(() => props.items[activeItemIndex.value]);

const chooseItem = (index: number) => {
  activeItemIndex.value = index;
};

return { __sfc: true,props, activeItemIndex, activeItem, chooseItem, AbSection, AbTitle, AbDescription, AbContainer, AbSectionLayout, AbButton, CdnImg }
}

})